// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card[data-v-01c7bd90]:not(:last-child) {\n  margin-bottom: 1.25rem;\n}", ""]);
// Exports
module.exports = exports;
